import { CATEGORIES, pkSlidersForCategory, agSlidersForCategory } from '../../lib/matching/catalog'

/** Visualisiert das -5..+5-Slider-Profil einer Pflegekraft oder Einrichtung. */
export default function SliderProfile({
  answers,
  side,
}: {
  answers: Record<string, number> | null | undefined
  side: 'candidate' | 'employer'
}) {
  const data = answers || {}
  const total = Object.keys(data).length

  if (total === 0) {
    return <p className="empty-hint">Noch kein Slider-Profil hinterlegt.</p>
  }

  return (
    <div className="profile-sliders">
      {CATEGORIES.map((cat) => {
        const sliders = side === 'employer' ? agSlidersForCategory(cat.id) : pkSlidersForCategory(cat.id)
        if (sliders.length === 0) return null
        return (
          <div key={cat.id} className="profile-slider-cat">
            <div className="profile-slider-cat-title">
              {cat.icon} {cat.label}
            </div>
            {sliders.map((s) => {
              const value = data[s.id]
              return (
                <div key={s.id} className="profile-slider-row">
                  <span className="profile-slider-row-label">
                    {side === 'employer' ? s.labelEmployer : s.labelCandidate}
                  </span>
                  <Scale value={value ?? null} />
                  <span className="profile-slider-val">
                    {value === undefined || value === null ? '–' : value > 0 ? `+${value}` : value}
                  </span>
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

function Scale({ value }: { value: number | null }) {
  const v = value ?? 0
  const pct = ((v + 5) / 10) * 100
  const color = value === null ? '#CBD5E1' : v > 0 ? '#0D9488' : v < 0 ? '#EF4444' : '#94A3B8'
  return (
    <div style={{ position: 'relative', width: 96, height: 6, background: '#F1F5F9', borderRadius: 99, flexShrink: 0 }}>
      <div style={{ position: 'absolute', left: '50%', top: -3, width: 1, height: 12, background: '#CBD5E1' }} />
      <div
        style={{
          position: 'absolute',
          left: `calc(${pct}% - 6px)`,
          top: -3,
          width: 12,
          height: 12,
          borderRadius: '50%',
          background: color,
          border: '2px solid white',
          boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
        }}
      />
    </div>
  )
}
